import { AxiosRequestConfig } from "axios";

import api from "@services/axios/bff";

import { ICustomApiOptions, useApi } from "./useApi";

export function useApiBff<T, D = unknown>(
  baseConfig: AxiosRequestConfig<D>,
  customConfig?: ICustomApiOptions,
) {
  return useApi<T, D>(
    api,
    {
      ...baseConfig,
      headers: {
        ...baseConfig.headers,
        // FIXME: adicionado em todos os ambientes, para validar segurança
        // do bff de cartões. Vai ser resolvido com o COBYX
        "x-auth-bff": "6c6286179e074cbdbdce804c272f8b5f",
      },
    },
    customConfig,
  );
}
